import { UPDATE } from 'admin-on-rest';
export const PROJECT_IMPORT = 'PROJECT_IMPORT';
export const PROJECT_UPLOAD = 'PROJECT_UPLOAD';
export const PROJECT_EXPORT = 'PROJECT_EXPORT';
export const PROJECT_REACTIVATE = 'PROJECT_REACTIVATE';

export const projectCustomAction = (
  type,
  id,
  data,
  action,
  resource,
  fetch
) => ({
  type,
  payload: { id, data: { ...data }, action },
  meta: {
    resource: resource || 'projects',
    fetch: fetch || UPDATE,
    cancelPrevious: false
  }
});

export const projectImport = (id, data) =>
  projectCustomAction(PROJECT_IMPORT, id, data, 'import');

export const projectUpload = (id, data) =>
  projectCustomAction(PROJECT_UPLOAD, id, data, 'upload');

export const projectExport = (id, data) =>
  projectCustomAction(PROJECT_EXPORT, id, data, 'export');

export const projectReactivate = (id, data) =>
  projectCustomAction(PROJECT_REACTIVATE, id, data, 'reactivate');



// WEBPACK FOOTER //
// ./src/actions/customProjectActions.js